let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3vvSh")).then(() => parcelRequire('7EztE'));